<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="industry.name"
          label="Name"
          hide-details="auto"
          maxlength="100"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="industry.urlSegment"
          label="Url Segment"
          hide-details="auto"
          maxlength="100"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12">
        <v-select
          v-model="industry.industryTypeId"
          :items="industry_types"
          hide-details="auto"
          label="Industry Type"
          item-value="id"
          item-text="name"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="industry.designNotes"
          label="Design Notes"
          hide-details
          outlined
        />
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="industry.excludeFromProfession"
          label="Exclude from Profession?"
          hide-details
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AddIndustry',

  data() {
    return {
      industry: {},
      valid: false,
      saving: false
    };
  },
  computed: {
    ...mapGetters({ industry_types: 'lookup/industry_types' })
  },
  mounted() {
    this.industry = {};
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      this.$store
        .dispatch('industries/create', this.industry)
        .then(() => {
          this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_HIDE);
          this.$root.$snackbarSuccess('Industry created');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
